import Typography from '@mui/material/Typography';
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from '@mui/material/styles';

const theme = createTheme({
  typography: {
    h1: {
      fontFamily: ['Poppins', 'Arial', 'sans-serif'].join(','),
      textTransform: 'none',
      fontSize: 38,
    },
    h3: {
      fontFamily: ['Poppins', 'Arial', 'sans-serif'].join(','),
      textTransform: 'none',
      fontSize: 30,
    },
    h4: {
      fontFamily: ['Poppins', 'Arial', 'sans-serif'].join(','),
      textTransform: 'none',
      fontSize: 24,
    },
  },
});

const responsiveTheme = responsiveFontSizes(theme);

const Title = (props) => {
  return (
    <ThemeProvider theme={responsiveTheme}>
      <Typography color="textPrimary" variant="h1" gutterBottom>
        {props.title}
      </Typography>
    </ThemeProvider>
  );
};

const Subtitle = (props) => {
  return (
    <ThemeProvider theme={responsiveTheme}>
      <Typography color="textPrimary" variant="h3" gutterBottom>
        {props.title}
      </Typography>
    </ThemeProvider>
  );
};

const Headline = (props) => {
  return (
    <ThemeProvider theme={responsiveTheme}>
      <Typography color="textPrimary" variant="h4" gutterBottom>
        {props.title}
      </Typography>
    </ThemeProvider>
  );
};

export { Subtitle, Headline };
export default Title;
